module.exports = __webpack_public_path__ + "media/devise/background-vindi-af722e81.png";